<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
              :showBtn="false"
              :showAddNew="false"
              title="Provident Fund Import"
            >
                <template #extra-btn>
                    <a
                        download
                        href="/file/import-provident-fund.xlsx"
                        class="btn btn-outline-secondary waves-effect waves-float waves-light"
                    >Download Sample
                    </a>
                </template>
            </TitleButton>
            <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
        </div>

        <div class="row p-2">
            <div class="col-12 col-sm-6 col-md-5 col-lg-4">
                <label for="colFormLabel" class="col-form-label">Select Type</label>
                <v-select
                    placeholder="Select Provident Fund"
                    v-model="providentFund"
                    :options="providentFundType"
                    :reduce="name => name.value"
                    label="name"
                />
            </div>
            <div class="col-12 col-sm-6 col-md-5 col-lg-4">
              <label for="colFormLabel" class="col-form-label">Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="providentDate"
              >
            </div>
            <div v-show="providentFund && providentDate" class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="uploadCsv" class="btn btn-primary waves-effect waves-float waves-light">
                    Browse
                </button>
            </div>
        </div>

        <div class="p-2">
            <div v-for="(item, index) in csvRow" :key="index">
                <div class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center">
                    <span class="cursor-pointer px-1" @click="gotoUpload(item.id)">id: {{ item.id }} Dataset: {{ item.batch }}</span>
                    <span class="cursor-pointer px-1 text-danger" @click="deleteRow(item.id)"><i class="fas fa-trash"></i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import { inject, onMounted, ref } from "vue";
import { useRoute, useRouter } from 'vue-router';
import handleInventory from "@/services/modules/inventory";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const { fetchCsvRow, deleteCsvRow } = handleInventory();
const {
  fetchTypes,
  uploadProvidentFund
} = handleHrPayroll()

const uploader = ref(null);
const csvRow = ref([]);
const providentFundType = ref([]);
const providentFund = ref('')
const providentDate = ref('')

const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const gotoUpload = (id) => {
    const query = Object.assign({}, route.query);
    query.row_id = id;

    router.push({name: 'upload-provident-fund', params: route.params, query: query});
}

const getCsvRow = async () => {
    let query = `?company_id=${route.params.companyId}&type=provident_fund`;
    await fetchCsvRow(query).then((res) => {
        if(!res.status) {
            return
        }
        csvRow.value = res.data
    }).catch((e) => {
        console.log(e)
    });
}

const deleteRow = async (id) => {
    if(!confirm('Are you sure you want to delete this row?')) return;

    let query = `?company_id=${route.params.companyId}&type=provident_fund`;
    
    await deleteCsvRow(query, id).then((res) => {
        if(!res.status) {
            return showError(res.message);
        }
        csvRow.value = [];
        getCsvRow();
        showSuccess(res.message)
    }).catch((e) => {
        console.log(e)
    });
}

const getTypes = async () => {
  let query = `?company_id=${route.params.companyId}`;
  await fetchTypes(query).then(res => {
    if (!res.status){
      providentFundType.value = [];
      return
    }

    if (res.data && res.data.providentFundType) {
      providentFundType.value = res.data.providentFundType;
    }

  }).catch(err => {
    console.log(err)
  })
}

const uploadCsv = () => {
    uploader.value.click();
}

const handleFileUpload = async (event) => {
    if(! providentFundType.value) {
        return showError('Please select Type')
    }

    if(! providentDate.value) {
      return showError('Please select Date')
    }

    const selectedFile = event.target.files[0];

    let fd = new FormData();
    fd.append('company_id', route.params.companyId)
    fd.append('sheet', selectedFile)
    fd.append('type', 'provident_fund');
    fd.append('provident_fund_type', providentFund.value);
    fd.append('date', providentDate.value);

    await uploadProvidentFund(fd).then((res) => {
        if(!res.status) {
            showError(res.message)
            return
        }
        
        showSuccess(res.message)
        getCsvRow();
    })
    .catch((e) => {
        showError('Something went wrong')
    });
}

onMounted(() => {
    getCsvRow();
    getTypes()
})

</script>